module.exports = __webpack_public_path__ + "static/media/black_logo.5ab7241d.svg";